import { render, staticRenderFns } from "./leaveRequest.vue?vue&type=template&id=789d56aa&"
import script from "./leaveRequest.vue?vue&type=script&lang=js&"
export * from "./leaveRequest.vue?vue&type=script&lang=js&"
import style0 from "./leaveRequest.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports